// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type CreditCard24CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const CreditCard24Circle: FC<CreditCard24CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="33"
        >
            <path d="M23.2 10.902v1.75H8.8v-1.75h14.4ZM8.8 21.402v-5.25h14.4v5.25H8.8Z" />
            <path
                d="M16 32.152c8.837 0 16-7.164 16-16 0-8.837-7.163-16-16-16s-16 7.163-16 16c0 8.836 7.163 16 16 16Zm8.471-9.514c.353-.343.529-.755.529-1.236v-10.5c0-.481-.176-.893-.529-1.236a1.759 1.759 0 0 0-1.271-.514H8.8c-.495 0-.919.171-1.271.514A1.662 1.662 0 0 0 7 10.902v10.5c0 .481.176.893.529 1.236.352.342.776.514 1.271.514h14.4c.495 0 .919-.172 1.271-.514Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default CreditCard24Circle;
